import { HTTPClient } from "../utils/request"

export default {
  groups: ({ query = `` }) => HTTPClient.get(`/users/acl/group${query}`),
  group: ({ params }) => HTTPClient.get(`/users/acl/group/${params.id}`),
  new_group: ({ payload }) => HTTPClient.post(`/users/acl/group`, payload),
  edit_group: ({ params, payload }) => HTTPClient.put(`/users/acl/group/${params.id}`, payload),
  delete_group: ({ params }) => HTTPClient.delete(`/users/acl/group/${params.id}`),

  roles: ({ query = `` }) => HTTPClient.get(`/users/acl/roles${query}`),
  role: ({ params }) => HTTPClient.get(`/users/acl/roles/${params.id}`),
  new_role: ({ payload }) => HTTPClient.post(`/users/acl/roles`, payload),
  edit_role: ({ params, payload }) => HTTPClient.put(`/users/acl/roles/${params.id}`, payload),
  delete_role: ({ params }) => HTTPClient.delete(`/users/acl/roles/${params.id}`),

  policies: ({ query = `` }) => HTTPClient.get(`/users/acl/policies${query}`),
  policy: ({ params }) => HTTPClient.get(`/users/acl/policies/${params.id}`),
  new_policy: ({ payload }) => HTTPClient.post(`/users/acl/policies`, payload),
  edit_policy: ({ params, payload }) => HTTPClient.put(`/users/acl/policies/${params.id}`, payload),
  delete_policy: ({ params }) => HTTPClient.delete(`/users/acl/policies/${params.id}`),
}
